import { useEffect, useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import { Link, useLocation } from 'react-router-dom'
import defaultLogo from 'assets/icon/logo/[PC]logo_du_original_200.png'
import whiteLogo from 'assets/icon/logo/[PC]logo_du_white_200.png'
import ellipseIcon from 'assets/icon/menu/Ellipse 57.png'
import whiteMenu from 'assets/icon/menu/img_du_menu-3.png'
import defaultMenu from 'assets/icon/menu/img_du_menu-4.png'
import clickMenu from 'assets/icon/menu/img_du_menu-5.png'
import { useRecoilValue } from 'recoil'
import STYLE_GUIDE from 'shared/constants/color'
import { headerBlurFlag } from 'shared/store/index'
import styled, { css } from 'styled-components'

const Header = () => {
  const [menuFlag, setMenuFlag] = useState(false)
  const [showMobileMenu, setShowMobileMenu] = useState(false)
  const [hoveredItem, setHoveredItem] = useState(null)
  const [blurFlag, setBlurFlag] = useState()
  const { pathname } = useLocation()
  const blurCheck = useRecoilValue(headerBlurFlag)
  const isMobile = useMediaQuery({
    query: '(max-width:1199px)',
  })

  const menuList = isMobile
    ? [
        { num: 1, name: '데이터유니버스', link: 'information' },
        { num: 2, name: '서비스', link: 'service' },
        { num: 3, name: '기부', link: 'csr/donation' },
        { num: 4, name: '캠페인', link: 'csr/campaign' },
        { num: 5, name: '뉴스', link: 'news' },
        { num: 6, name: '채용안내', link: 'recruit' },
      ]
    : [
        { num: 1, name: '데이터유니버스', link: 'information' },
        { num: 2, name: '서비스', link: 'service' },
        { num: 3, name: '사회공헌', link: 'csr/donation' },
        { num: 4, name: '뉴스', link: 'news' },
        { num: 5, name: '채용안내', link: 'recruit' },
      ]

  const onClick = () => {
    setShowMobileMenu(!showMobileMenu)
  }

  const handleMouseEnter = (item) => {
    setHoveredItem(item)
  }

  const handleMouseLeave = () => {
    setHoveredItem(null)
  }

  const menuClick = () => {
    const header = document.querySelector('.header')
    const depth2 = document.querySelectorAll('.depth2')
    header?.classList.remove('on')
    depth2.forEach((ele) => ele.classList.remove('on'))
  }

  useEffect(() => {
    const header = document.querySelector('.header')
    // const mainMenu = document.querySelector('.main-menu')
    const depth2 = document.querySelectorAll('.depth2')

    // mainMenu?.addEventListener('mouseenter', (event) => {
    //   header?.classList.add('on')
    //   depth2.forEach((ele) => ele.classList.add('on'))
    //   setMenuFlag(true)
    // })

    const test = document.querySelectorAll('.menu')

    Array.prototype.forEach.call(test, function (e) {
      e?.addEventListener('mouseenter', (event) => {
        header?.classList.add('on')
        depth2.forEach((ele) => ele.classList.add('on'))
        setMenuFlag(true)
      })
    })

    header?.addEventListener('mouseleave', (event) => {
      header?.classList.remove('on')
      depth2.forEach((ele) => ele.classList.remove('on'))
      setMenuFlag(false)
    })
  }, [menuFlag, isMobile])

  // const scrollHandler = (e) => {

  //   const scroll = document.querySelector('header').clientTop

  useEffect(() => {
    if (pathname !== '/') {
      setBlurFlag(true)
    } else if (pathname === '/' && blurCheck) {
      setBlurFlag(true)
    } else {
      setBlurFlag(false)
    }
  })

  useEffect(() => {
    setBlurFlag(blurCheck)
  }, [blurCheck])

  useEffect(() => {
    const menu = document.querySelectorAll('.menu')
    // document.querySelectorAll('.menu').
    Array.prototype.forEach.call(menu, function (e) {
      e.classList.remove('active')
      if (pathname === '/information' && e.innerText === '데이터유니버스') {
        e.classList.add('active')
        setHoveredItem(1)
      }
      if (pathname === '/service' && e.innerText === '서비스') {
        e.classList.add('active')
        setHoveredItem(2)
      }
      if (pathname === '/csr/donation' && e.innerText === '사회공헌') {
        e.classList.add('active')
        setHoveredItem(3)
      }
      if (pathname === '/csr/campaign' && e.innerText === '사회공헌') {
        e.classList.add('active')
        setHoveredItem(4)
      }
      if (pathname === '/news' && e.innerText === '뉴스') {
        e.classList.add('active')
        setHoveredItem(5)
      }
      if (pathname === '/recruit' && e.innerText === '채용안내') {
        e.classList.add('active')
        setHoveredItem(6)
      }
    })
  }, [pathname])

  const logoClick = () => {
    const path = window.location.pathname
    if (path === '/') {
      window.location.reload()
    }
  }

  useEffect(() => {
    const body = document.getElementsByTagName('body')[0]
    showMobileMenu ? body.classList.add('scroll_lock') : body.classList.remove('scroll_lock')
  }, [showMobileMenu])

  return (
    <>
      {isMobile ? (
        <MobileHeaderWrap
          pathname={pathname}
          blurFlag={blurFlag}
          showMobileMenu={showMobileMenu}
          className="header"
        >
          {showMobileMenu && (
            <MobileMenu>
              <div className="container">
                <ul>
                  {menuList.map((item, index) => (
                    <Link to={item.link} onClick={onClick} key={index}>
                      <li
                        key={item.num}
                        onMouseEnter={() => handleMouseEnter(item.num)}
                        onMouseLeave={() => handleMouseLeave()}
                        className="menu_list"
                      >
                        {hoveredItem === item.num ? (
                          <img
                            src={ellipseIcon}
                            style={{ visibility: 'visible' }}
                            alt={item.name}
                          />
                        ) : (
                          <img src={ellipseIcon} style={{ visibility: 'hidden' }} alt={item.name} />
                        )}
                        <div className="menu_link">{item.name}</div>
                      </li>
                    </Link>
                  ))}
                </ul>
              </div>
            </MobileMenu>
          )}
          <div className="m_header">
            <div className="logo_area">
              {(pathname !== '/' && !showMobileMenu) || (blurFlag && !showMobileMenu) ? (
                <Link
                  to="/"
                  onClick={() => {
                    setShowMobileMenu(false)
                    handleMouseLeave()
                    logoClick()
                  }}
                >
                  <img className="logo" src={defaultLogo} alt={'로고'} />
                </Link>
              ) : (
                <Link
                  to="/"
                  onClick={() => {
                    setShowMobileMenu(false)
                    handleMouseLeave()
                    logoClick()
                  }}
                >
                  <img className="logo" src={whiteLogo} alt={'로고'} />
                </Link>
              )}
            </div>
            <MenuWrap className="menu_area">
              {pathname !== '/' && !showMobileMenu && (
                <button
                  className="hambuger_btn"
                  onClick={onClick}
                  style={{
                    backgroundImage: `url(${defaultMenu})`,
                    width: '26px',
                    height: '26px',
                  }}
                ></button>
              )}
              {pathname === '/' && !showMobileMenu && !blurFlag && (
                <button
                  className="hambuger_btn"
                  onClick={onClick}
                  style={{
                    backgroundImage: `url(${whiteMenu})`,
                    width: '26px',
                    height: '26px',
                  }}
                ></button>
              )}
              {pathname === '/' && !showMobileMenu && blurFlag && (
                <button
                  className="hambuger_btn"
                  onClick={onClick}
                  style={{
                    backgroundImage: `url(${defaultMenu})`,
                    width: '26px',
                    height: '26px',
                  }}
                ></button>
              )}
              {showMobileMenu && (
                <button
                  className="hambuger_btn"
                  onClick={onClick}
                  style={{
                    backgroundImage: `url(${clickMenu})`,
                    width: '26px',
                    height: '26px',
                  }}
                ></button>
              )}
            </MenuWrap>
          </div>
        </MobileHeaderWrap>
      ) : (
        <HeaderWrap
          className="header"
          menuFlag={menuFlag}
          pathname={pathname}
          blurFlag={blurFlag}
          blurCheck={blurCheck}
        >
          <div className="container">
            <div>
              {menuFlag || pathname !== '/' || blurCheck ? (
                <Link
                  to="/"
                  onClick={() => {
                    logoClick()
                  }}
                >
                  <img className="logo" src={defaultLogo} alt="datauniverse" />
                </Link>
              ) : (
                <Link
                  to="/"
                  onClick={() => {
                    logoClick()
                  }}
                >
                  <img className="logo" src={whiteLogo} alt="datauniverse" />
                </Link>
              )}
            </div>
            <MenuWrap menuFlag={menuFlag} pathname={pathname}>
              <ul className="main-menu">
                <li className="info_tab">
                  <Link to="information" className="menu" onClick={() => menuClick()}>
                    데이터유니버스
                  </Link>
                  <ul className="depth2">
                    <li onClick={() => menuClick()}>
                      <Link to={'information'} state={{ state: 1 }}>
                        회사소개
                      </Link>
                    </li>
                    <li onClick={() => menuClick()}>
                      <Link to={'information'} state={{ state: 2 }}>
                        특허 및 인증
                      </Link>
                    </li>
                    <li onClick={() => menuClick()}>
                      <Link to={'information'} state={{ state: 3 }}>
                        히스토리
                      </Link>
                    </li>
                    <li onClick={() => menuClick()}>
                      <Link to={'information'} state={{ state: 4 }}>
                        파트너
                      </Link>
                    </li>
                    <li onClick={() => menuClick()}>
                      <Link to={'information'} state={{ state: 5 }}>
                        CI
                      </Link>
                    </li>
                    <li onClick={() => menuClick()}>
                      <Link to={'information'} state={{ state: 6 }}>
                        Contact us
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="service_tab">
                  <Link to="service" className="menu" onClick={() => menuClick()}>
                    서비스
                  </Link>
                  <ul className="depth2">
                    <li onClick={() => menuClick()}>
                      <Link to="service">서비스소개</Link>
                    </li>
                  </ul>
                </li>
                <li className="csr_tab">
                  <Link to="csr/donation" className="menu" onClick={() => menuClick()}>
                    사회공헌
                  </Link>
                  <ul className="depth2">
                    <li onClick={() => menuClick()}>
                      <Link to="csr/donation">기부</Link>
                    </li>
                    <li onClick={() => menuClick()}>
                      <Link to="csr/campaign">캠페인</Link>
                    </li>
                  </ul>
                </li>
                <li className="news_tab">
                  <Link to="news" className="menu" onClick={() => menuClick()}>
                    뉴스
                  </Link>
                  <ul className="depth2">
                    <li onClick={() => menuClick()}>
                      <Link to="news">뉴스</Link>
                    </li>
                  </ul>
                </li>
                <li className="recurit_tab">
                  <Link to="recruit" className="menu" onClick={() => menuClick()}>
                    채용안내
                  </Link>
                  <ul className="depth2">
                    <li onClick={() => menuClick()}>
                      <Link to="recruit" state={{ state: 1 }}>
                        DU와 함께해요
                      </Link>
                    </li>
                    <li onClick={() => menuClick()}>
                      <Link to="recruit" state={{ state: 2 }}>
                        채용 공고
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </MenuWrap>
          </div>
        </HeaderWrap>
      )}
    </>
  )
}

export default Header

const DefaultHeader = styled.header`
  z-index: 15;
  width: 100%;
  position: fixed;
  top: 0;

  > .container {
    display: flex;
    position: relative;
    align-items: center;
  }
`

const HeaderWrap = styled(DefaultHeader)`
  transition: all 0.2s ease-in-out;

  ${(props) =>
    props.blurFlag &&
    css`
      background: rgba(255, 255, 255, 0.9);
    `}

  ${(props) =>
    props.blurFlag &&
    css`
      backdrop-filter: blur(5px);
    `}

  ${(props) =>
    props.blurCheck &&
    css`
      .main-menu {
        .menu {
          color: #252525;
        }
      }
    `}

  .logo {
    cursor: pointer;
  }

  .main-menu {
    > li {
      > a {
        font-size: 20px;
        font-weight: 500;
      }
    }

    .info_tab {
    }

    .service_tab {
    }
  }

  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 100px;
    left: 0;
    width: 100%;
    height: 0;
    background: ${STYLE_GUIDE.COLOR.white};
    border-top: 1px solid ${STYLE_GUIDE.COLOR.gray2};
    box-shadow: 0px 30px 36px rgba(0, 0, 0, 0.06);
    transition: all 0.2s ease;
    opacity: 0;
  }

  &.on {
    background: ${STYLE_GUIDE.COLOR.white};
    transition: all 0.1s ease;
    &:after {
      opacity: 1;
      height: 360px;
    }
  }

  .depth2.on {
    display: block;
  }

  .depth2 {
    display: none;
    position: absolute;
    top: 100px;
    z-index: 5;
  }
`

const MobileHeaderWrap = styled(DefaultHeader)`
  .logo {
    width: 135px;
    cursor: pointer;
  }

  .m_header {
    ${(props) =>
      props.blurFlag &&
      !props.showMobileMenu &&
      css`
        background: rgba(255, 255, 255, 0.9);
      `}

    ${(props) =>
      props.blurFlag &&
      !props.showMobileMenu &&
      css`
        backdrop-filter: blur(1px);
      `}
    display: flex;
    justify-content: space-between;
    position: fixed;
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;

    .logo_area {
      margin: 21px 0 21px 60px;
    }

    .menu_area {
      margin: 15px 60px 15px 0;
    }
  }

  @media screen and (max-width: 883px) {
    .m_header {
      .logo_area {
        margin: 21px 0 21px 20px;
      }

      .menu_area {
        margin: 15px 20px 15px 0;
      }
    }
  }
`

const MobileMenu = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  padding-top: 110px;
  background: ${STYLE_GUIDE.COLOR.black1};

  .container .menu_list {
    display: flex;
    align-items: center;
    height: 60px;
    padding-bottom: 10px;
    font-weight: 700;
    font-size: 24px;
    line-height: 35px;
    color: ${STYLE_GUIDE.COLOR.white};

    img {
      width: 8px;
      padding-right: 10px;
    }
  }

  .menu_link {
    color: ${STYLE_GUIDE.COLOR.white};
  }
`

const MenuWrap = styled.div`
  margin-left: auto;

  .main-menu {
    text-align: center;
    line-height: 100px;

    .info_tab {
      width: 129px;

      .depth2 {
        width: 129px;
      }
    }

    .service_tab {
      width: 83px;

      .depth2 {
        width: 83px;
      }
    }

    .csr_tab {
      width: 114px;

      .depth2 {
        width: 114px;
      }
    }

    .news_tab {
      width: 37px;

      .depth2 {
        width: 37px;
      }
    }

    .recurit_tab {
      width: 114px;

      .depth2 {
        width: 114px;
      }
    }
  }

  .main-menu > li {
    display: inline-block;
    padding-right: 100px;

    @media screen and (max-width: 1919px) {
      padding-right: 60px;
    }

    > a {
      color: ${(props) =>
        props.menuFlag || props.pathname !== '/'
          ? `${STYLE_GUIDE.COLOR.black1}`
          : `${STYLE_GUIDE.COLOR.white}`};

      &:hover {
        color: ${STYLE_GUIDE.COLOR.main1};
      }

      &.active {
        color: ${STYLE_GUIDE.COLOR.main1};
      }
    }

    :last-child {
      padding-right: 0px;
    }

    .depth2 {
      position: absolute;
      z-index: 5;
      font-weight: 400;
      font-size: 18px;
      color: ${STYLE_GUIDE.COLOR.black1};
      line-height: 30px;

      > li {
        padding-top: 20px;
      }
    }
  }

  .mobile_menu {
    position: fixed;
    background: ${STYLE_GUIDE.COLOR.black1};
    color: #fff;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    top: 70px;
    width: 100%;

    > ul > li {
      font-size: 28px;
      line-height: 40px;
      font-weight: 700;
    }
  }
`
